import { categoriesThatMayConflict, environment } from '@/helpers/Environment';
import { isTimedItem } from '@/store/CartItem';
/**
 * Returns sessions that conflict with any session for any other event for any tickets already in the cart.
 *
 * TODO Improve unit test coverage.
 * TODO Replace first two params with on EventDetails param?
 */
export function conflictingSessions(eventId, metadata, sessions, cartItems) {
    const cartSessions = cartItems
        // Cart items for special events like gift cards and memberships are untimed and don't conflict.
        .filter(isTimedItem)
        // All-day-entry items (e.g. general admission) never conflict.
        // TODO Deprecate all-day concept in favor of conflict_avoidance.exclude_categories?
        .filter((item) => !item.allDay)
        // Exclude cart items for events that never conflict.
        .filter((item) => !categoriesThatMayConflict.has(item.event.category))
        // Ignore sessions conflicting with the same event template we're
        // looking at sessions for. This will happen in edit mode.
        .filter((item) => eventId !== item.templateId);
    if (cartSessions.length < 1) {
        // There are no items in the cart that can conflict.
        return [];
    }
    else {
        // Return the sessions that overlap with a cart item session.
        const cartIntervals = cartSessions.map((session) => occupiedInterval(session, session.meta));
        return sessions.filter((session) => {
            const sessionInterval = occupiedInterval(session, metadata);
            return cartIntervals.some((interval) => intervalsOverlap(interval, sessionInterval));
        });
    }
}
function intervalsOverlap(a, b) {
    // Partial overlaps:
    //       ========
    //     ----    ----
    // Contained:
    //       ========
    //         ----
    //     ------------
    // Edges touch:
    //       ========
    //       --------
    //       ---  ---
    //       -----------
    //     ----------
    // No overlap:
    //       ========
    //   ----        ----
    // ----            ----
    // Items overlap if both opposite ends of each interval are in order.
    // @see https://stackoverflow.com/questions/13513932/algorithm-to-detect-overlapping-periods
    return a.start.isBefore(b.end) && b.start.isBefore(a.end);
}
function occupiedInterval(item, templateMetaData) {
    const { startTime, endTime } = item;
    const preStart = paddingConfig('pad_pre_start', templateMetaData);
    const postEnd = paddingConfig('pad_post_end', templateMetaData);
    return {
        start: startTime.subtract(preStart, 'minutes'),
        end: endTime.add(postEnd, 'minutes'),
    };
}
/**
 * Gets a padding variable, taking care to return any 0 values.
 */
function paddingConfig(metadataKey, metadata) {
    const configKey = `default_${metadataKey}`;
    const config = environment.web.conflict_avoidance;
    if (metadata[metadataKey] != null) {
        return Number(metadata[metadataKey]);
    }
    else if (config?.[configKey] != null) {
        return config[configKey];
    }
    else {
        return 5; // minutes
    }
}
